<div class="rx-lightbox" role="dialog" aria-modal="true" [attr.aria-label]="'RELEASE_NOTES.CARD.LIGHTBOX_LABEL' | translate"
     (keydown.escape)="onEscape($event)" (click)="onBackdrop($event)">
  <button #closeButton type="button" class="rx-lightbox__close" (click)="closed.emit()"
          [attr.aria-label]="'RELEASE_NOTES.CARD.CLOSE_LIGHTBOX' | translate">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <div class="rx-lightbox__content" (click)="onBackdrop($event)" (keydown.escape)="onEscape($event)">
    <ng-container *ngIf="url; else missing">
      <video *ngIf="isVideo; else still" [src]="url" controls autoplay muted [muted]="true" playsinline></video>
      <ng-template #still><img [src]="url" [attr.alt]="alt"></ng-template>
    </ng-container>
    <ng-template #missing><p class="rx-lightbox__missing">{{ alt }}</p></ng-template>
  </div>
</div>
